var SERVER_URL = "https://i13hpc29.ira.uka.de/api/";
const MOCK_BACKEND = false;

export { SERVER_URL, MOCK_BACKEND };